/* eslint-disable multiline-ternary */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { BarraDeTitulo } from '../../components/BarraDeTitulo'
import FeatherIcon from 'feather-icons-react'
import Swal from 'sweetalert2'
import { CloudSave } from '../../public/SVG/CloudSave'
import axios from 'axios'
import { api } from '../../services/api'
import styles from "./stylesCadastroDashBoard.module.css"
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useContext } from 'react'
import MyContext from '../../contexts/myContext'

import "../../components/stylesGuia.css"
import RichTextEditor from '../../components/RichTextEditor'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { MenuExportacao } from '../../components/MenuExportacao'
import { ListaDashboards } from '../../components/ListaDashboards'
import LoadingSpinner from '../../components/Loanding/LoadingSpinner'
import { GravaLogB2B } from '../Login/functions/GravaLogB2B'

export default function CadastroDashBoard() {
  const [textButtonSave, setTextButtonSave] = useState('Cadastrar novo Dash')
  const [textSegundaAba, setTextSegundaAba] = useState('Cadastrar novo Dash')
  const [dashboards, setDashboards] = useState([])
  const [ListaDashPermitidosUsuario, setListaDashPermitidosUsuario] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [listaLogAlteracoes, setListaLogAlteracoes] = useState([])
  const [departamento, setDepartamento] = useState('Selecione um Departamento')
  const [TipoCarrossel, setTipoCarrossel] = useState('DASH NATIVO')
  const [DashSelecionadoCarrossel, setDashSelecionadoCarrossel] = useState('Selecione um Dash')
  const [descricao, setDescricao] = useState('')
  const [idDashEdit, setIdDashEdit] = useState('')
  const [nomeAmigavel, setNomeAmigavel] = useState('')
  const [departamentos, setDepartamentos] = useState([])
  const [linkDash, setLinkDash] = useState('')
  const [linkCarrossel, setLinkCarrossel] = useState('')
  const [linkHelp, setLinkHelp] = useState('')
  const [DescritivoDash, setDescritivoDash] = useState('')
  const [opTempoAtualizacao, setOpTempoAtualizacao] = useState('NÃO ESPECIFICADO')

  const [minutosTempoAtualizacao, setMinutosTempoAtualizacao] = useState('')
  const [minutosCarrossel, setMinutosCarrossel] = useState('')
  const [diasPeriodoInicial, setDiasPeriodoInicial] = useState('')
  const [opPeriodoInicialPesquisa, setOpPeriodoInicialPesquisa] = useState('NÃO ESPECIFICADO')
  const [opTipoDash, setOpTipoDash] = useState('DASH PADRÃO')
  const [disable, setDisable] = useState([])

  const [dashFiltro, setDashfiltro] = useState('')
  const [dashboards_Full, setDashboards_Full] = useState([])

  const [ComposicaoCarrossel, setComposicaoCarrossel] = useState([])

  const [isLoadingCarrossel, setIsLoadingCarrossel] = useState(false)

  function filtrarArray(arrayDados) {

    let arrayTotal = arrayDados

    if (dashFiltro) {
      const vNomeFiltrado = arrayTotal.filter(item => {
        const itemData = `${item.NomeAmigavel.toUpperCase()}
          ${item.Descricao.toUpperCase()}
        `;

        const textData = dashFiltro.toUpperCase();

        return itemData.indexOf(textData) > -1;
      });

      arrayTotal = vNomeFiltrado
    }

    return arrayTotal
  }

  useEffect(() => {
    setDashboards(filtrarArray(dashboards_Full))
  }, [dashFiltro])

  const [ordemDash, setOrdemDash] = useState(true)
  const [orderBy, setOrderBy] = useState(true)

  const [respeitarRegrasHierarquia, setRespeitarRegrasHierarquia] = useState(false)
  const [ExibirBarraInformacoes, setExibirBarraInformacoes] = useState(false)


  const handleEditorFullScreen = useFullScreenHandle()
  const [isFullScreenEditor, setIsFullScreenEditor] = useState(false)

  function setFullScreenEditor() {
    if (isFullScreenEditor) {
      handleEditorFullScreen.exit()
      setIsFullScreenEditor(false)
    } else {
      handleEditorFullScreen.enter()
      setIsFullScreenEditor(true)
    }
  }


  useEffect(() => {
    if (opTempoAtualizacao === 'NÃO ESPECIFICADO') {
      setMinutosTempoAtualizacao('')
      window.document.getElementById('minutosTempoAtualizacao').value = ''
    }
  }, [opTempoAtualizacao])

  useEffect(() => {
    if (opPeriodoInicialPesquisa === 'NÃO ESPECIFICADO') {
      setDiasPeriodoInicial('')
      window.document.getElementById('diasPeriodoInicial').value = ''
    }
  }, [opPeriodoInicialPesquisa])

  useEffect(() => {
    getListaDepartamentos()
    getDashBoards()
  }, [])

  useEffect(() => {
    if (descricao && nomeAmigavel && departamento && departamento !== 'Selecione um Departamento') {
      setDisable(false)
    } else {
      setDisable(true)
    }
  }, [descricao, nomeAmigavel, departamento])


  function scrollTopPage() {
    function scrollToTop(element) {
      element.scrollTop = 0;
    }
    var scrollableElements = document.querySelectorAll('.scrollable');
    scrollableElements.forEach(scrollToTop);
  }

  function handleClearInputs() {
    setTextButtonSave('Cadastrar novo Dash')
    setTextSegundaAba('Cadastrar novo Dash')
    setDepartamento('Selecione um Departamento')
    setDescricao('')
    setIdDashEdit('')
    setNomeAmigavel('')
    setLinkDash('')
    setLinkHelp('')
    setDescritivoDash('')
    setRespeitarRegrasHierarquia(false)
    setExibirBarraInformacoes(false)
    setEmpresasSelecionadas([])
    setEmpresas([])
    getEmpresas()
    setListaLogAlteracoes([])
    setOpTempoAtualizacao('NÃO ESPECIFICADO')
    setOpPeriodoInicialPesquisa('NÃO ESPECIFICADO')
    setOpTipoDash('DASH PADRÃO')
    setDiasPeriodoInicial('')
    setMinutosTempoAtualizacao('')

    //CARROSSEL
    setComposicaoCarrossel([])
    LimpaCamposCarrossel()



    window.document.getElementById('departamento').value = 'Selecione um Departamento'
    window.document.getElementById('descricao').value = ''
    window.document.getElementById('amigavel').value = ''
    window.document.getElementById('minutosTempoAtualizacao').value = ''
    window.document.getElementById('diasPeriodoInicial').value = ''
    window.document.getElementById('fileInputDash').value = null

    document.getElementById('imgPreviewDash').src = 'DashPreviewJPG.jpg'

    scrollTopPage()

  }


  const getLogAlteracoesDash = async (idDash) => {
    await api
      .get(`/dashboard/api/listalogdashboard/${idDash}`)
      .then(data => {
        setListaLogAlteracoes(data.data)
      })
      .catch(error => console.log(error))
  }

  async function encheCamposTela(key) {

    setIdDashEdit(dashboards[key].Id)
    setLinkDash(dashboards[key].LinkDash)
    setOpTipoDash(dashboards[key].opTipoDash)
    setLinkHelp(dashboards[key].LinkHelp)
    setDescritivoDash(dashboards[key].DescritivoDash)
    setDescricao(dashboards[key].Descricao)
    setNomeAmigavel(dashboards[key].NomeAmigavel)
    setDepartamento(dashboards[key].Departamento)
    setRespeitarRegrasHierarquia(dashboards[key].respeitarRegrasHierarquia)
    setExibirBarraInformacoes(dashboards[key].ExibirBarraInformacoes)
    setOpTempoAtualizacao(dashboards[key].opTempoAtualizacao)
    setMinutosTempoAtualizacao(dashboards[key].minutosTempoAtualizacao)
    setOpPeriodoInicialPesquisa(dashboards[key].opPeriodoInicialPesquisa)
    setOpTipoDash(dashboards[key].opTipoDash)
    setDiasPeriodoInicial(dashboards[key].diasPeriodoInicial)

    window.document.getElementById('amigavel').value = dashboards[key].NomeAmigavel
    window.document.getElementById('descricao').value = dashboards[key].Descricao
    window.document.getElementById('departamento').value = dashboards[key].Departamento
    window.document.getElementById('minutosTempoAtualizacao').value = dashboards[key].minutosTempoAtualizacao
    window.document.getElementById('diasPeriodoInicial').value = dashboards[key].diasPeriodoInicial
    setTextButtonSave('Atualizar dados do Dash')
    setTextSegundaAba('Editando dados do Dash Nº ' + dashboards[key].Id)

    await getLogAlteracoesDash(dashboards[key].Id)
    await listarEmpresasSelecionadas(dashboards[key].Id)
    await getComposicaoCarrossel(dashboards[key].Id)

    document.getElementById('imgPreviewDash').src = `${api.defaults.baseURL}/dashboard/api/getImagemFundoDash/${dashboards[key].Id}`
    window.document.getElementById('fileInputDash').value = null
    await LimpaCamposCarrossel()

    setToggleState(2)

  }

  function handleShowLogs(log) {
    const htmlText = `
    Data: <b>${log.DataAlteracaoFormat}</b><br>
    Usuário: <b>${log.NomeUsuario}</b><br>
    Tipo: <b>${log.acao}</b><br><br>
    ${log.Descricao ? `Nome: <b>${log.Descricao}</b><br>` : ''}
    ${log.IdDepartamento ? `Departamento: <b>${departamentos.filter(dep => dep.Id == log.IdDepartamento)[0]?.Descricao?.toUpperCase()}</b><br>` : ''}
    ${log.NomeAmigavel ? `Nome Amigável: <b>${log.NomeAmigavel}</b><br>` : ''}
    ${log.LinkDash ? `Link: <b>${log.LinkDash}</b><br>` : ''}
    ${log.opTipoDash ? `Tipo Dash: <b>${log.opTipoDash}</b><br>` : ''}
    ${log.LinkHelp ? `Link Help: <b>${log.LinkHelp}</b><br>` : ''}
    ${log.DescritivoDash ? `Descritivo Dash: <b>${log.DescritivoDash}</b><br>` : ''}
    ${log.respeitarRegrasHierarquia !== null ? `Respeitar Hierarquia: <b>${log.respeitarRegrasHierarquia}</b><br>` : ''}
    ${log.ExibirBarraInformacoes !== null ? `Barra de Informações: <b>${log.ExibirBarraInformacoes}</b><br>` : ''}
    ${log.opTempoAtualizacao || log.minutosTempoAtualizacao ? `Tempo de Atualização: <b>${log.opTempoAtualizacao || ''} ${log.minutosTempoAtualizacao !== null && log.minutosTempoAtualizacao ? `${log.minutosTempoAtualizacao}min` : ''} </b><br>` : ''}
    ${log.opPeriodoInicialPesquisa || log.diasPeriodoInicial ? `Período inicial de Pesquisa: <b>${log.opPeriodoInicialPesquisa || ''} ${log.diasPeriodoInicial !== null ? `${log.diasPeriodoInicial} dia(s)` : ''} </b><br>` : ''}
    `
    Swal.fire({
      title: "<i>Alterações</i>",
      html: htmlText,
      confirmButtonText: "Voltar",
    });
  }

  async function deleteImagemFundoDash(idDashDel) {
    const urlDel = `/dashboard/api/excluirImagemFundoDash/${idDashDel}`
    if (idDashDel === '') {
      document.getElementById('imgPreviewDash').src = 'DashPreviewJPG.jpg'
      window.document.getElementById('fileInputDash').value = null
      return
    }

    await api(urlDel, {
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    }).then(() => {
      Swal.fire('Imagem de Fundo', 'Excluída com sucesso', 'success')
      document.getElementById('imgPreviewDash').src = 'DashPreviewJPG.jpg'
      window.document.getElementById('fileInputDash').value = null
    }).catch(error => {
      console.log(error)
    })
  }


  async function InsertUsuariosDashboards(idDashInsert) {
    try {
      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: {
          SQL_Execute: `INSERT INTO usuariosdashboards (Id_Usuario,IdDashboard) VALUES (
            ${user.idUsuario}, ${idDashInsert}
          )
          ` }
      })
    } catch (error) {
      console.log('Erro em InsertUsuariosDashboards')
      console.log(error)
    }
  }


  async function DeleteUsuariosDashboards(idDashExclusao) {
    try {
      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: { SQL_Execute: `DELETE FROM usuariosdashboards WHERE IdDashboard = ${idDashExclusao}` }
      })
    } catch (error) {
      console.log('Erro em DeleteDashUsuarios')
      console.log(error)
    }
  }

  async function handleExcluirDash(idDashExclusao) {
    try {
      Swal.fire({
        title: `Deseja excluir o Dash Nº ${idDashExclusao}?`,
        text: 'Você não será capaz de reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          api('/dashboard/api/query_execute', {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            data: { SQL_Execute: `DELETE FROM empresasdashboards WHERE IdDashboard = ${idDashExclusao}` }
          }).then(() => {
            api('/dashboard/api/query_execute', {
              method: 'put',
              headers: { 'Content-Type': 'application/json' },
              data: { SQL_Execute: `DELETE FROM dashboards WHERE ID = ${idDashExclusao}` }
            }).then(() => {
              api('/dashboard/api/query_execute', {
                method: 'put',
                headers: { 'Content-Type': 'application/json' },
                data: { SQL_Execute: `DELETE FROM log_dashboards WHERE idDash = ${idDashExclusao}` }
              }).then(async () => {
                api('/dashboard/api/query_execute', {
                  method: 'put',
                  headers: { 'Content-Type': 'application/json' },
                  data: { SQL_Execute: `DELETE FROM ComposicaoCarrossel WHERE IdDashboard = ${idDashExclusao}` }
                })
                  .then(async () => {
                    await DeleteUsuariosDashboards(idDashExclusao)
                    Swal.fire('Excluído', 'Dash excluído com sucesso!', 'success')
                    getDashBoards()
                    getListaDepartamentos()
                    handleClearInputs()
                    await deleteImagemFundoDash(idDashExclusao)
                  })
              }).catch(error => {
                console.log(error)
                Swal.fire({
                  icon: 'error',
                  text: 'Erro ao Excluir o Dash! ' + error,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
            }).catch(error => {
              Swal.fire({
                icon: 'error',
                text: 'Erro ao Excluir o Dash! ' + error,
                showConfirmButton: false,
                timer: 5000
              })
            })
          }).catch(error => {
            console.log(error)
            Swal.fire({
              icon: 'error',
              text: 'Erro ao Excluir o Dash! ' + error,
              showConfirmButton: false,
              timer: 5000
            })
          })
        }
      })
    } catch (error) {
      console.log('Erro handleExcluirDash')
      console.log(error)
    }
  }

  async function excluiDashBoard(dashboard) {
    try {
      const idDashExclusao = dashboards[dashboard].Id
      await api.get(`/dashboard/api/listaComposicaoCarrossel/${idDashExclusao}`)
        .then(async data => {
          const results = data.data
          if (results.length > 0) {
            Swal.fire({
              icon: 'error',
              text: `Carrossel com composição cadastrada! Remova os arquivos para continuar.`,
              showConfirmButton: false,
              timer: 8000
            })
          }
          else {
            await handleExcluirDash(idDashExclusao)
          }
        })
        .catch(error => {
          console.log('Erro em getComposicaoCarrossel')
          console.log(error)
        })


    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: 'Erro na Exclusão do Dash ' + error,
        showConfirmButton: false,
        timer: 7000
      })
    }

  }


  const { addTab, setLinkDash: setLinkDashContext, user } = useContext(MyContext)

  async function criaDashboard() {
    const IdDepartamento = departamentos.filter(ID => ID.Descricao === window.document.getElementById('departamento').value)

    const JSONDashboard = {
      Descricao: window.document.getElementById('descricao').value,
      NomeAmigavel: window.document.getElementById('amigavel').value,
      IdDepartamento: IdDepartamento[0].Id,
      LinkDash: linkDash,
      LinkHelp: linkHelp,
      DescritivoDash: DescritivoDash,
      opTipoDash: opTipoDash,
      respeitarRegrasHierarquia: respeitarRegrasHierarquia,
      ExibirBarraInformacoes: ExibirBarraInformacoes,
      opTempoAtualizacao: opTempoAtualizacao,
      minutosTempoAtualizacao: minutosTempoAtualizacao,
      opPeriodoInicialPesquisa: opPeriodoInicialPesquisa,
      diasPeriodoInicial: diasPeriodoInicial,
      UsuarioLog: user.idUsuario,
    }




    if (idDashEdit) {
      const checkDescricao = dashboards?.filter(dash => dash.Id !== idDashEdit && dash.Descricao?.toLowerCase() === window.document.getElementById('descricao').value?.toLowerCase())
      if (checkDescricao.length > 0) {
        Swal.fire({
          icon: 'error',
          text: 'Nome do Dash já existente!',
          showConfirmButton: false,
          timer: 5000
        })
        return
      }

      const checkNomeAmigavel = dashboards?.filter(dash => dash.Id !== idDashEdit && dash.NomeAmigavel?.toLowerCase() === window.document.getElementById('amigavel').value?.toLowerCase())
      if (checkNomeAmigavel.length > 0) {
        Swal.fire({
          icon: 'error',
          text: 'Nome Amigável do Dash já existente!',
          showConfirmButton: false,
          timer: 5000
        })
        return
      }
    }
    else {
      const checkDescricao = dashboards?.filter(dash => dash?.Descricao?.toLowerCase() === window.document.getElementById('descricao').value?.toLowerCase())
      if (checkDescricao.length > 0) {
        Swal.fire({
          icon: 'error',
          text: 'Nome do Dash já existente!',
          showConfirmButton: false,
          timer: 5000
        })
        return
      }

      const checkAmigavel = dashboards?.filter(dash => dash?.NomeAmigavel?.toLowerCase() === window.document.getElementById('amigavel').value?.toLowerCase())
      if (checkAmigavel.length > 0) {
        Swal.fire({
          icon: 'error',
          text: 'Nome Amigável do Dash já existente!',
          showConfirmButton: false,
          timer: 5000
        })
        return
      }
    }



    if (idDashEdit) {
      await api(`/dashboard/api/atualizaDashboard/${idDashEdit}`, {
        method: 'put',
        data: JSONDashboard
      }).then(async () => {
        await postListaEmpresasDash(idDashEdit)
        Swal.fire({
          icon: 'success',
          text: 'Dash atualizado com sucesso',
          showConfirmButton: false,
          timer: 3000
        })
        getDashBoards()
        getLogAlteracoesDash(idDashEdit)

        //handleClearInputs()
      })
        .catch(error => {
          console.log(error)
        })
    } else {
      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: { SQL_Execute: `ALTER TABLE dashboards AUTO_INCREMENT=1;` }
      }).then(async (res) => {
        await api('/dashboard/api/criarDashboard/', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          data: JSONDashboard
        }).then(async (res) => {
          const insertId = res.data.insertId
          await postListaEmpresasDash(insertId)
          setIdDashEdit(insertId)

          uploadFile(null, insertId)

          await InsertUsuariosDashboards(insertId)

          Swal.fire({
            icon: 'success',
            text: 'Dash criado com sucesso',
            showConfirmButton: false,
            timer: 3000
          })
          setTextSegundaAba('Editando dados do Dash Nº ' + insertId)
          setTextButtonSave('Atualizar dados do Dash')
          getDashBoards()
          getLogAlteracoesDash(insertId)

          //handleClearInputs()
        })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              text: 'Erro ao cadastrar o Dashboard. ' + error + ' ' + error?.response?.data?.sqlMessage,
              showConfirmButton: false,
              timer: 5000
            })
            console.log(error)
          })

      })

    }
  }

  async function postListaEmpresasDash(idDash) {
    try {
      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: { SQL_Execute: `DELETE FROM empresasdashboards WHERE IdDashboard = ${idDash}` }
      }).then(async () => {
        if (empresasSelecionadas.length > 0) {
          await api.post(`/dashboard/api/insereEmpresasDash`,
            {
              idDash: idDash, empresas: empresasSelecionadas
            },
            {
              headers: { 'Content-Type': 'application/json' },
            }
          ).then(() => {

          })
        }
      }).catch(error => {
        console.log(error)
      })
    } catch (error) {
      console.log(`Erro em postListaEmpresasDash/insereEmpresasDash`)
    }
  }

  const getListaDepartamentos = async () => {
    await api
      .get('/departamento/api/listaDepartamento')
      .then(data => {
        setDepartamentos(data.data)
      })
      .catch(error => console.log(error))
  }

  const getDashBoards = async () => {
    await api
      .get('/dashboard/api/listaDashboard')
      .then(data => {
        setDashboards(filtrarArray(data.data))
        setDashboards_Full(data.data)
      })
      .catch(error => console.log(error))

    const registrosDashPermitidos = await getListaDashPermitidosUsuario()
    setListaDashPermitidosUsuario(registrosDashPermitidos)
  }

  async function getListaDashPermitidosUsuario() {
    let registros = []
    try {
      await api
        .get('/usuario/api/listaDashboardUsuario', { params: { IdUsuario: user?.idUsuario } })
        .then(data => {
          registros = data.data.filter(dash => dash.CheckDash === 1)
        })
        .catch(error => {
          console.log('erro em listaDashboardUsuario')
          console.log(error)
        })
    } catch (error) {
      console.log('erro em getListaDashPermitidosUsuario')
      console.log(error)
    }
    finally {
      return registros
    }
  }

  const getEmpresas = async () => {
    await api
      .get('/api/empresa/getDadosGeral')
      .then(data => {
        setEmpresas(data.data)
      })
      .catch(error => console.log(error))
  }

  useEffect(() => {
    getEmpresas()
  }, [])

  async function listarEmpresasSelecionadas(IdDash) {
    await api
      .get(`/dashboard/api/listaEmpresasDash/${IdDash}`)
      .then(data => {
        setEmpresas(data.data)
        setEmpresasSelecionadas(data.data.filter(empresa => empresa.CheckEmpresa === 1).map(empresa => {
          return (
            empresa.CPF_CNPJ
          )
        }))
      })
      .catch(error => console.log(error))
  }

  async function getComposicaoCarrossel(IdDash) {
    await api.get(`/dashboard/api/listaComposicaoCarrossel/${IdDash}`)
      .then(data => {
        const results = data.data
        setComposicaoCarrossel(results)
        console.log('results')
        console.log(results)
      })
      .catch(error => {
        console.log('Erro em getComposicaoCarrossel')
        console.log(error)
      })
  }


  const [empresasSelecionadas, setEmpresasSelecionadas] = useState([])

  function popularEmpresasSelecionadas(vCPF_CNPJ, checked) {
    if (checked) {
      setEmpresasSelecionadas([...empresasSelecionadas, vCPF_CNPJ])
    } else {
      setEmpresasSelecionadas(empresasSelecionadas.filter(CPF_CNPJ => CPF_CNPJ !== vCPF_CNPJ))
    }

    const ArrayEmpresa = empresas.filter(Id => Id.CPF_CNPJ === vCPF_CNPJ)

    ArrayEmpresa[0].CheckEmpresa = checked

    const ArrayEmpresaFinal = empresas.filter(Id => Id.CPF_CNPJ !== vCPF_CNPJ)

    ArrayEmpresaFinal.push(ArrayEmpresa[0])



    setEmpresas(ArrayEmpresaFinal)
  }

  const handleChangeOpTempoAtualizacao = (event) => {
    setOpTempoAtualizacao((event.target).value);
  };

  const handleChangeOpPeriodoInicialPesquisa = (event) => {
    setOpPeriodoInicialPesquisa((event.target).value);
  };

  const handleChangeOpTipoDash = (event) => {
    setOpTipoDash((event.target).value);
  };


  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };


  const uploadFile = async (file, idDashEditParam) => {

    const formData = new FormData()
    const imagefile = document.querySelector('#fileInputDash')

    const extensaoArquivo = imagefile?.files[0]?.name?.split('.')?.slice(-1)[0]

    if (typeof (extensaoArquivo) === 'undefined') {
      return
    }


    if (extensaoArquivo.toString().toLowerCase() !== 'png') {
      return Swal.fire({
        icon: 'error',
        text: 'Arquivo inválido! Selecione um PNG!',
        showConfirmButton: false,
        timer: 5000
      })
    }


    document.getElementById('imgPreviewDash').src = window.URL.createObjectURL(imagefile.files[0])


    if (idDashEditParam === '') {
      return
    }

    formData.append('logodash', imagefile.files[0])

    const API_ENDPOINT = `/dashboard/api/upload-photos-dash/${idDashEditParam}/${extensaoArquivo}`

    await api.post(
      API_ENDPOINT,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
      .then(response => {
        Swal.fire({
          icon: 'success',
          text: response.data,
          showConfirmButton: false,
          timer: 3000
        })
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          text: 'Erro ao gravar a Imagem de Fundo. ' + error,
          showConfirmButton: false,
          timer: 5000
        })
        console.log('erro: ' + error)
      })
  }

  function ExportEditor() {
    alert('export')
  }

  async function LimpaCamposCarrossel() {
    setTipoCarrossel('DASH NATIVO')
    setDashSelecionadoCarrossel('Selecione um Dash')
    setLinkCarrossel('')
    setMinutosCarrossel('')
    window.document.getElementById('ImagemCarrossel').value = null
    window.document.getElementById('VideoCarrossel').value = null
  }

  const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false)

  async function handleSalvarComposicao() {
    try {

      if (!idDashEdit) {
        return
      }



      if (ComposicaoCarrossel.length > 0) {
        if (!parseFloat(minutosCarrossel) > 0) {
          Swal.fire({
            icon: 'error',
            text: 'Informe os minutos para a Composição! Já existe um ou mais item lançado.',
            showConfirmButton: false,
            timer: 5000
          })

          return
        }
      }


      if (TipoCarrossel === 'DASH NATIVO' && DashSelecionadoCarrossel === 'Selecione um Dash') {
        Swal.fire({
          icon: 'error',
          text: 'Selecione um Dash para continuar!',
          showConfirmButton: false,
          timer: 5000
        })

        return
      }

      if (TipoCarrossel === 'LINK' && linkCarrossel === '') {
        Swal.fire({
          icon: 'error',
          text: 'Informe um Link para continuar!',
          showConfirmButton: false,
          timer: 5000
        })

        return
      }

      const formData = new FormData()

      const imagefile = document.querySelector('#ImagemCarrossel')

      let vNomeImagem = imagefile?.files[0]?.name || ''

      const VideoFile = document.querySelector('#VideoCarrossel')

      let vNomeVideo = VideoFile?.files[0]?.name || ''

      console.log('VideoFile?.files[0]')
      console.log(VideoFile?.files[0])

      if (TipoCarrossel === 'VÍDEO' && !vNomeVideo) {
        Swal.fire({
          icon: 'error',
          text: 'Selecione um Vídeo para continuar!',
          showConfirmButton: false,
          timer: 5000
        })

        return
      }

      if (TipoCarrossel === 'IMAGEM' && !vNomeImagem) {
        Swal.fire({
          icon: 'error',
          text: 'Selecione uma Imagem para continuar!',
          showConfirmButton: false,
          timer: 5000
        })

        return
      }

      setIsLoadingUploadFile(true)
      setIsLoadingCarrossel(true)

      let vMaxCodigoItem = 0

      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: {
          SQL_Execute: `SELECT IFNULL(MAX(CodigoItem),0) + 1 AS MaxCodigoItem FROM ComposicaoCarrossel WHERE IdDashboard = ${idDashEdit}`
        }
      }).then(async (response) => {
        vMaxCodigoItem = response?.data[0]?.MaxCodigoItem || 1

        let nomePersonalizado = ''

        var dataAtual = new Date();
        var dataFormatada =
          dataAtual.getDate().toString().padStart(2, '0') + '-' +
          (dataAtual.getMonth() + 1).toString().padStart(2, '0') + '-' +
          dataAtual.getFullYear().toString() + '-' +
          dataAtual.getHours().toString().padStart(2, '0') + '.' +
          dataAtual.getMinutes().toString().padStart(2, '0') + '.' +
          dataAtual.getSeconds().toString().padStart(2, '0');
        console.log('dataFormatada');
        console.log(dataFormatada);


        if (vNomeImagem) {
          vNomeImagem = `${vNomeImagem.replace('.png', '')}_${dataFormatada}.png`
          formData.append('arquivo-carrossel', imagefile.files[0])
          nomePersonalizado = vNomeImagem
        }

        if (vNomeVideo) {
          vNomeVideo = `${vNomeVideo.replace('.mp4', '')}_${dataFormatada}.mp4`
          formData.append('arquivo-carrossel', VideoFile.files[0])
          nomePersonalizado = vNomeVideo
        }

        console.log('formData')
        console.log(formData)

        console.log('TipoCarrossel')
        console.log(TipoCarrossel)

        if (TipoCarrossel === 'VÍDEO' || TipoCarrossel === 'IMAGEM') {
          await api.post(`/dashboard/api/upload-arquivos-carrossel/${nomePersonalizado}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
            }
          )
            .then(response => {
              console.log('### response.data de upload-arquivos-carrossel')
              console.log(response.data)
            })
            .catch(error => {
              Swal.fire({
                icon: 'error',
                text: 'Erro ao gravar o arquivo do Carrossel.  ' + error,
                showConfirmButton: false,
                timer: 5000
              })
              console.log('erro: em upload-arquivos-carrossel de handleSalvarComposicao ')
              console.log(error)
            })
        }

        await api('/dashboard/api/query_execute', {
          method: 'put',
          headers: { 'Content-Type': 'application/json' },
          data: {
            SQL_Execute: `
            INSERT INTO ComposicaoCarrossel (IdDashboard, CodigoItem, Tipo, IdDashboardSelecionado, LinkSelecionado, ImagemSelecionada, VideoSelecionado, MinutosDuracao, Ordem) 
            VALUES (
              ${idDashEdit}, (SELECT IFNULL(MAX(AUX.CodigoItem),0) + 1 AS MaxCodigoItem FROM ComposicaoCarrossel AUX WHERE IdDashboard = ${idDashEdit}),
              '${TipoCarrossel}', ${DashSelecionadoCarrossel !== 'Selecione um Dash' ? `${DashSelecionadoCarrossel}` : null}, '${linkCarrossel}',
              '${vNomeImagem}', '${vNomeVideo}', ${minutosCarrossel || 0}, (SELECT IFNULL(MAX(AUX.Ordem),0) + 1 AS MaxOrdem FROM ComposicaoCarrossel AUX WHERE IdDashboard = ${idDashEdit})
            );`
          }
        }).then(async () => {
          await getComposicaoCarrossel(idDashEdit)
          Swal.fire('Sucesso', 'Composição salva', 'success')
          await LimpaCamposCarrossel()
        }).catch(error => {
          console.log(error)
          Swal.fire({
            icon: 'error',
            text: 'Erro ao cadastrar a Composição. ' + error,
            showConfirmButton: false,
            timer: 5000
          })
        })
      }).catch(error => {
        console.log(error)
        Swal.fire({
          icon: 'error',
          text: 'Erro ao cadastrar a Composição. ' + error,
          showConfirmButton: false,
          timer: 5000
        })
      })
    } catch (error) {
      console.log('Erro em handleSalvarComposicao')
      console.log(error)
    }
    finally {
      setIsLoadingUploadFile(false)
      setIsLoadingCarrossel(false)
    }
  }


  async function handleExcluirComposicao(vCodigoItem, Tipo, vNomeArquivo) {
    Swal.fire({
      title: 'Deseja excluir este Cadastro de Composição?',
      text: 'Também será excluido o Vídeo/Imagem caso tenha!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (Tipo === 'VÍDEO' || Tipo === 'IMAGEM') {
          const urlDel = `/dashboard/api/excluir-arquivo-carrossel/${vNomeArquivo}`
          await api(urlDel, {
            method: 'delete',
            headers: { 'Content-Type': 'application/json' },
          }).then(() => {

          }).catch(error => {
            console.log(error)
          })
        }

        await api('/dashboard/api/query_execute', {
          method: 'put',
          headers: { 'Content-Type': 'application/json' },
          data: {
            SQL_Execute: `DELETE FROM ComposicaoCarrossel WHERE IdDashboard = ${idDashEdit} AND CodigoItem = ${vCodigoItem}`
          }
        }).then(async () => {

          await api('/dashboard/api/query_execute', {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            data: {
              SQL_Execute: `
              UPDATE Composicaocarrossel c
                JOIN (
                    SELECT CodigoItem, IdDashboard, @new_order := @new_order + 1 AS new_order
                    FROM (
                        SELECT CodigoItem, IdDashboard
                        FROM Composicaocarrossel
                        WHERE IdDashboard = ${idDashEdit}
                        ORDER BY Ordem
                    ) AS sub
                    CROSS JOIN (SELECT @new_order := 0) AS init
                ) AS ordered_records
                ON c.CodigoItem = ordered_records.CodigoItem AND c.IdDashboard = ordered_records.IdDashboard
                SET c.Ordem = ordered_records.new_order
                WHERE c.IdDashboard = ${idDashEdit};
              `
            }
          }).then(async () => {
            await getComposicaoCarrossel(idDashEdit)
            Swal.fire('Sucesso', 'Composição Excluída', 'success')
          }).catch(error => {
            console.log(error)
            Swal.fire({
              icon: 'error',
              text: 'Erro ao Excluir a Composição. ' + error,
              showConfirmButton: false,
              timer: 5000
            })
          })
        }).catch(error => {
          console.log(error)
          Swal.fire({
            icon: 'error',
            text: 'Erro ao Excluir a Composição. ' + error,
            showConfirmButton: false,
            timer: 5000
          })
        })
      }
    })
  }

  async function handleSubirOrdemComposicao(vCodigoItem, vOrdem) {
    if (vOrdem === 1) {
      return
    }

    try {
      setIsLoadingCarrossel(true)

      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: {
          SQL_Execute: `
            UPDATE ComposicaoCarrossel
            SET Ordem = Ordem - 1
            WHERE IdDashboard = ${idDashEdit} AND CodigoItem = ${vCodigoItem}
          `
        }
      }).then(async () => {
        //await getComposicaoCarrossel(idDashEdit)
        await api('/dashboard/api/query_execute', {
          method: 'put',
          headers: { 'Content-Type': 'application/json' },
          data: {
            SQL_Execute: `
              UPDATE ComposicaoCarrossel
              SET Ordem = Ordem + 1
              WHERE IdDashboard = ${idDashEdit} AND CodigoItem <> ${vCodigoItem} AND Ordem = ${vOrdem - 1}
            `
          }
        }).then(async () => {
          await getComposicaoCarrossel(idDashEdit)
        }).catch(error => {
          console.log(error)
          Swal.fire({
            icon: 'error',
            text: 'Erro ao Mudar a ordem da Composição. ' + error,
            showConfirmButton: false,
            timer: 5000
          })
        })
      }).catch(error => {
        console.log(error)
        Swal.fire({
          icon: 'error',
          text: 'Erro ao Mudar a ordem da Composição. ' + error,
          showConfirmButton: false,
          timer: 5000
        })
      })
    } catch (error) {
      console.log('Erro em handleSubirOrdemComposicao')
      console.log(error)
    }
    finally {
      setIsLoadingCarrossel(false)
    }
  }

  async function handleDescerOrdemComposicao(vCodigoItem, vOrdem) {
    if (vOrdem === ComposicaoCarrossel.length) {
      return
    }

    try {
      setIsLoadingCarrossel(true)

      await api('/dashboard/api/query_execute', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        data: {
          SQL_Execute: `
            UPDATE ComposicaoCarrossel
            SET Ordem = Ordem + 1
            WHERE IdDashboard = ${idDashEdit} AND CodigoItem = ${vCodigoItem}
          `
        }
      }).then(async () => {
        //await getComposicaoCarrossel(idDashEdit)
        await api('/dashboard/api/query_execute', {
          method: 'put',
          headers: { 'Content-Type': 'application/json' },
          data: {
            SQL_Execute: `
              UPDATE ComposicaoCarrossel
              SET Ordem = Ordem - 1
              WHERE IdDashboard = ${idDashEdit} AND CodigoItem <> ${vCodigoItem} AND Ordem = ${vOrdem + 1}
            `
          }
        }).then(async () => {
          await getComposicaoCarrossel(idDashEdit)
        }).catch(error => {
          console.log(error)
          Swal.fire({
            icon: 'error',
            text: 'Erro ao Mudar a ordem da Composição. ' + error,
            showConfirmButton: false,
            timer: 5000
          })
        })
      }).catch(error => {
        console.log(error)
        Swal.fire({
          icon: 'error',
          text: 'Erro ao Mudar a ordem da Composição. ' + error,
          showConfirmButton: false,
          timer: 5000
        })
      })
    } catch (error) {
      console.log('Erro em handleDescerOrdemComposicao')
      console.log(error)
    }
    finally {
      setIsLoadingCarrossel(false)
    }
  }


  const renderAbaCadastrarNovoDash = () => {
    return (
      <div className='border border-thirdColor p-2 rounded-lg '>

        <div className=' my-2 flex flex-col  h-full'>
          <div className='flex flex-row   gap-4 mb-4 '>

            <div className='divDepartamento'>
              <p className='text-sm text-primaryColor '>
                DEPARTAMENTO:
              </p>
              <div className='flex flex-row  '>
                <select
                  required
                  onChange={event => setDepartamento(event.target.value)} id='departamento' className={`${styles.selectDepartamento} uppercase bg-gray-50 border border-gray-300  text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block  p-0.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}>
                  <option selected>Selecione um Departamento</option>
                  {
                    departamentos.sort((a, b) => (a.Descricao > b.Descricao) ? 1 : -1).map(departamento => {
                      return (
                        <option key={departamento.Descricao} value={departamento.Descricao}>{departamento.Descricao}</option>
                      )
                    })
                  }
                </select>
              </div>
              {
                departamento === 'Selecione um Departamento' ?
                  <p style={{ fontSize: 11, color: 'red', marginTop: '0.2rem' }} >* Informe um Departamento</p>
                  : null
              }
            </div>


            <div className='divNomeDash w-full' >
              <div className='flex flex-col w-full'>
                <p className='text-sm text-primaryColor'>
                  NOME DO DASH:
                </p>
                <input autocomplete="off" placeholder='nomedash' onChange={event => setDescricao(event.target.value)} id='descricao' className='pl-1 rounded-md shadow-lg  text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor' />
                {
                  !descricao ?
                    <p style={{ fontSize: 11, color: 'red', marginTop: '0.2rem' }} >* Digite um Nome</p>
                    : null
                }
              </div>
            </div>

            <div className='divNomeAmigavel w-full' >
              <div className='flex flex-col w-full'>
                <p className='text-sm text-primaryColor'>
                  NOME AMIGÁVEL:
                </p>
                <input autocomplete="off" placeholder='NOME AMIGÁVEL PARA O DASH' onChange={event => setNomeAmigavel(event.target.value)} id='amigavel' className='uppercase pl-1 rounded-md shadow-lg  text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor' />
                {
                  !nomeAmigavel ?
                    <p style={{ fontSize: 11, color: 'red', marginTop: '0.2rem' }} >* Digite um Nome Amigável</p>
                    : null
                }
              </div>
            </div>

          </div>

          <div
            style={{


            }} className={`${styles.divMidleFilds} flex flex-row gap-[1rem] `}
          >
            <div className='flex flex-col w-[50%]'>
              <p className='text-sm text-primaryColor'>
                DASH POR LINK?:
              </p>
              <input
                autocomplete="off"
                id='linkDash'
                type='url'
                value={linkDash}
                onChange={event => setLinkDash(event.target.value)}
                placeholder='http://dashexterno.com.br/dash'
                className=' px-1 rounded-md shadow-lg text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
              />
            </div>

            <div className='w-fit flex flex-col gap-[0.5rem]'>
              <div className='border border-thirdColor rounded-lg w-fit px-2 ' >
                <FormControlLabel

                  className=' w-full'

                  control={<Checkbox

                    size="small"


                    sx={{
                      "&, & + .MuiFormControlLabel-label": {
                        color: "#3c4983",
                        fontSize: '0.675rem'
                      },
                      '& .MuiSvgIcon-root': { fontSize: 18 }



                    }}

                    checked={respeitarRegrasHierarquia}
                    onChange={() => setRespeitarRegrasHierarquia(!respeitarRegrasHierarquia)}
                  />}
                  label="VISUALIZAÇÃO DAS INFORMAÇÕES RESPEITANTO HIERARQUIA DO DEPARTAMENTO"

                />
              </div>

              <div className='border border-thirdColor rounded-lg w-fit px-2 ' >
                <FormControlLabel

                  className=' w-full'

                  control={<Checkbox

                    size="small"


                    sx={{
                      "&, & + .MuiFormControlLabel-label": {
                        color: "#3c4983",
                        fontSize: '0.675rem'
                      },
                      '& .MuiSvgIcon-root': { fontSize: 18 }



                    }}

                    checked={ExibirBarraInformacoes}
                    onChange={() => setExibirBarraInformacoes(!ExibirBarraInformacoes)}
                  />}
                  label="EXIBIR BARRA DE INFORMAÇÕES"

                />
              </div>
            </div>

          </div>

          <div className='flex flex-row gap-4 mt-4 ' >
            <div className={`${styles.tabelas} w-full`}>
              <p className='text-sm text-primaryColor mt-4'>
                EMPRESAS:
              </p>

              <div className='max-h-40 max-w-lg overflow-scroll' >
                <table className='w-full'>
                  <thead className='sticky top-0'>
                    <tr className='bg-primaryColor text-sm text-white-100 text-left'>
                      <th className=' text-center px-1'>Ativar</th>
                      <th className='px-1'>CPF/CNPJ</th>
                      <th className='px-1'>Empresa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empresas.length > 0 ? (
                      empresas.sort((a, b) => (a.CPF_CNPJ > b.CPF_CNPJ) ? 1 : -1).map((dashs, key) => (
                        <tr key={key} className='odd:bg-white-100 even:bg-lightgray uppercase text-sm'>
                          <td className='text-center'>{
                            <input checked={dashs.CheckEmpresa} onChange={(e) => popularEmpresasSelecionadas(dashs.CPF_CNPJ, e.target.checked)} name='habilita' id='habilita' type='checkbox'></input>
                          }</td>
                          <td >{dashs.CPF_CNPJ}</td>
                          <td >{dashs.NomeAmigavel}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className='bg-white-100 w-full'>
                        <td className='text-center italic text-sm' colSpan="4">Nenhum registro encontrado</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>

            <div className='flex flex-col w-fit' >
              <p className='text-sm text-primaryColor mt-4 truncate '>
                TEMPO DE ATUALIZAÇÃO:
              </p>

              <div className='border border-thirdColor  rounded-lg w-fit mt-1 p-2 ' >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={opTempoAtualizacao}
                    onChange={handleChangeOpTempoAtualizacao}
                  >
                    <FormControlLabel
                      value="NÃO ESPECIFICADO"
                      className='text-ellipsis '
                      control={
                        <Radio
                          sx={{
                            "&, & + .MuiFormControlLabel-label": {
                              color: "#3c4983",
                              fontSize: '0.675rem',

                            },
                            '& .MuiSvgIcon-root': { fontSize: 18 }
                          }}
                        />
                      }
                      label="NÃO ESPECIFICADO"
                    />

                    <FormControlLabel
                      value="ESPECIFICADO"
                      control={
                        <Radio
                          sx={{
                            "&, & + .MuiFormControlLabel-label": {
                              color: "#3c4983",
                              fontSize: '0.675rem'
                            },
                            '& .MuiSvgIcon-root': { fontSize: 18 }
                          }}
                        />
                      }
                      label="ESPECIFICADO"
                    />

                    <div style={{ display: opTempoAtualizacao === 'ESPECIFICADO' ? 'flex' : 'none' }} className='flex flex-col w-full  justify-center items-center'>
                      <p className='text-xs text-primaryColor'>
                        MINUTOS
                      </p>
                      <input
                        autocomplete="off"
                        maxLength={3}
                        onChange={event => setMinutosTempoAtualizacao(event.target.value)}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        id='minutosTempoAtualizacao'
                        className='w-[50%] text-center uppercase pl-1 rounded-md shadow-lg  text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className=' w-full '>
              <p className='text-sm text-primaryColor mt-4'>
                PERÍODO INICIAL DE PESQUISA:
              </p>

              <div className='border border-thirdColor w-full rounded-lg mt-1 p-2 ' >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={opPeriodoInicialPesquisa}
                    onChange={handleChangeOpPeriodoInicialPesquisa}
                  >
                    <div className='flex flex-row justify-between ' >
                      <div className=' w-full ' >
                        <FormControlLabel
                          value="NÃO ESPECIFICADO"
                          className='text-ellipsis '
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="NÃO ESPECIFICADO"
                        />

                        <FormControlLabel
                          value="ESPECIFICADO"
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="ESPECIFICADO"
                        />

                        <div style={{ display: opPeriodoInicialPesquisa === 'ESPECIFICADO' ? 'flex' : 'none' }} className='flex flex-col   justify-center items-center'>
                          <p className='text-xs text-primaryColor'>
                            QTD DIAS
                          </p>
                          <input
                            autocomplete="off"
                            maxLength={4}
                            onChange={event => setDiasPeriodoInicial(event.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault()
                              }
                            }}
                            id='diasPeriodoInicial'
                            className='w-[50%] text-center uppercase pl-1 rounded-md shadow-lg  text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                          />
                        </div>

                      </div>

                      <div className=' flex flex-col  w-full' >
                        <FormControlLabel
                          value="DIA ATUAL"
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="DIA ATUAL"
                        />

                        <FormControlLabel
                          value="SEMANA ATUAL"
                          className='text-ellipsis '
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'

                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="SEMANA ATUAL"
                        />




                      </div>

                      <div className='flex flex-col  w-full' >
                        <FormControlLabel
                          value="MÊS ATUAL"
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="MÊS ATUAL"
                        />

                        <FormControlLabel
                          value="TRIMESTRE ATUAL"
                          className='text-ellipsis '
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="TRIMESTRE ATUAL"
                        />

                        <FormControlLabel
                          value="ANO ATUAL"
                          control={
                            <Radio
                              sx={{
                                "&, & + .MuiFormControlLabel-label": {
                                  color: "#3c4983",
                                  fontSize: '0.675rem'
                                },
                                '& .MuiSvgIcon-root': { fontSize: 18 }
                              }}
                            />
                          }
                          label="ANO ATUAL"
                        />
                      </div>


                    </div>


                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className={`${styles.tabelas}  w-full`}>
              <p className='text-sm text-primaryColor mt-4'>
                LOG DE ALTERAÇÕES:
              </p>
              <div className='max-h-40 max-w-sm overflow-scroll' >
                <table className='w-full  '>
                  <thead className='sticky top-0'>
                    <tr className='bg-primaryColor text-sm text-white-100 text-left'>
                      <th className='pl-2'>DATA</th>
                      <th className='pl-1'>USUÁRIO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaLogAlteracoes.length > 0 ? (
                      listaLogAlteracoes.sort((a, b) => (a.DataAlteracao_ISO > b.DataAlteracao_ISO) ? 1 : -1).map((log, key) => (
                        <tr onClick={() => handleShowLogs(log)} key={key} className='odd:bg-white-100 even:bg-lightgray uppercase text-sm cursor-pointer'>

                          <td className='' >{log.DataAlteracaoFormat}</td>
                          <td className='pl-1 w-full' >{log.NomeUsuario}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className='bg-white-100 w-full  '>
                        <td className='text-center italic text-sm' colSpan="2">Nenhum registro encontrado</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>

          </div>

          <div className='flex flex-row gap-[1rem] mt-[1rem]' >
            <div
              style={{ borderRadius: '0.5rem' }}
              className='flex flex-col w-[45%] border h-fit border-thirdColor p-2 shadow-lg'
            >
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group-tipo"
                  value={opTipoDash}
                  onChange={handleChangeOpTipoDash}

                >
                  <p className='text-sm text-primaryColor'>
                    TIPO DO DASH
                  </p>
                  <div className='flex flex-col  w-full  rounded-lg mt-1 p-2' >
                    <div className='flex flex-col gap-1'>
                      <FormControlLabel
                        value="DASH PADRÃO"
                        disabled={ComposicaoCarrossel.length > 0 ? true : false}
                        control={
                          <Radio
                            sx={{
                              "&, & + .MuiFormControlLabel-label": {
                                color: "#3c4983",
                                fontSize: '0.675rem'
                              },
                              '& .MuiSvgIcon-root': { fontSize: 18 }
                            }}
                          />
                        }
                        label="DASH PADRÃO"
                      />
                      <FormControlLabel
                        value="CARROSSEL"
                        disabled={ComposicaoCarrossel.length > 0 ? true : false}
                        control={
                          <Radio
                            sx={{
                              "&, & + .MuiFormControlLabel-label": {
                                color: "#3c4983",
                                fontSize: '0.675rem'
                              },
                              '& .MuiSvgIcon-root': { fontSize: 18 }
                            }}
                          />
                        }
                        label="CARROSSEL"
                      />




                      <FormControlLabel
                        value="DASH CUSTOMIZADO"
                        disabled={ComposicaoCarrossel.length > 0 ? true : false}
                        className='text-ellipsis '
                        control={
                          <Radio
                            sx={{
                              "&, & + .MuiFormControlLabel-label": {
                                color: "#3c4983",
                                fontSize: '0.675rem'
                              },
                              '& .MuiSvgIcon-root': { fontSize: 18 }
                            }}
                          />
                        }
                        label="DASH CUSTOMIZADO"
                      />

                      <div className='flex flex-col w-full'>
                        <p className='text-sm text-primaryColor'>
                          LINK PARA EXPLICAÇÃO (AJUDA):
                        </p>
                        <input
                          autocomplete="off"
                          type='url'
                          placeholder='https://www.youtube.com/watch?v=AJUDADASH'
                          value={linkHelp}
                          onChange={event => setLinkHelp(event.target.value)}
                          id='linkHelp' className=' px-1 rounded-md shadow-lg text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor' />
                      </div>
                    </div>

                    <div className='flex flex-col gap-1 mt-3'>


                      <div className='flex flex-col w-full'>
                        <p className='text-sm text-primaryColor'>
                          DESCRITIVO DO DASH
                        </p>
                        {
                          /* 
                          <textarea
                          placeholder='DETALHE A DESCRIÇÃO DO DASH'
                          rows="8"
                          value={DescritivoDash}
                          onChange={event => setDescritivoDash(event.target.value)}
                          id='DescritivoDash'
                          className='resize-none mb-4 px-1 rounded-md shadow-lg text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                        />
                          */
                        }
                        <FullScreen className={`mt-[-2rem] useExport ${isFullScreenEditor && 'bg-white-100 px-2 '} relative w-full`} handle={handleEditorFullScreen}>
                          <MenuExportacao
                            isFullScreen={isFullScreenEditor}
                            ExportarComponente={() => ExportEditor()}
                            setFullScreen={() => setFullScreenEditor()}
                            hideExport={true}
                          />
                          <div className='pt-8' >
                            <RichTextEditor
                              setText={setDescritivoDash}
                              text={DescritivoDash}
                              isFullScreen={isFullScreenEditor}
                            />
                          </div>
                        </FullScreen>

                      </div>
                    </div>


                  </div>
                </RadioGroup>
              </FormControl>
            </div>




            <div className={`${opTipoDash === 'CARROSSEL' ? 'flex flex-col' : 'hidden'}  w-[55%] h-fit p-2 shadow-lg rounded-[0.5rem] border border-thirdColor`}>
              <p className='text-sm text-primaryColor'>
                COMPOSIÇÃO DO CARROSSEL:
              </p>

              <div className=' flex flex-col gap-[1rem] mt-1' >
                <div className='h-[30vh] min-h-[30vh] overflow-scroll ' >
                  <table className='w-full'>
                    <thead className='sticky top-0'>
                      <tr className='bg-primaryColor text-sm text-white-100 text-center'>
                        <th className='px-2 truncate'>Opções</th>
                        <th className='px-2 truncate'>Ordem</th>
                        <th className='px-2 truncate'>Tipo</th>
                        <th className='px-2 truncate'>Exibindo</th>
                        <th className='px-2 truncate'>Minutos</th>

                      </tr>
                    </thead>
                    <tbody>
                      {ComposicaoCarrossel.length > 0 ? (
                        ComposicaoCarrossel.sort((a, b) => (a.Ordem > b.Ordem) ? 1 : -1).map((dashs, key) => (
                          <tr key={key} className='odd:bg-white-100 even:bg-lightgray text-sm hover:bg-gray-300'>
                            <td className='truncate text-center px-2 !bg-white-200'>
                              {/* <button className='xl:text-sm 2xl:text-base hover:bg-blue-900 text-blue-900 font-semibold hover:text-white-100 py-1 px-2 border border-blue-900 rounded mr-1'
                                onClick={() => handleExcluirComposicao(dashs.CodigoItem, dashs.Tipo, dashs.Exibindo)}>
                                <FeatherIcon icon="edit" size={15} />
                              </button> */}

                              <button className='xl:text-sm 2xl:text-base hover:bg-blueInn-100 text-blueInn-100 font-semibold hover:text-white-100 py-1 px-2 border border-blueInn-100 rounded mr-1'
                                onClick={() => handleSubirOrdemComposicao(dashs.CodigoItem, dashs.Ordem)}>
                                <FeatherIcon icon="arrow-up" size={15} />
                              </button>

                              <button className='xl:text-sm 2xl:text-base hover:bg-black text-black font-semibold hover:text-white-100 py-1 px-2 border border-black rounded mr-1'
                                onClick={() => handleDescerOrdemComposicao(dashs.CodigoItem, dashs.Ordem)}>
                                <FeatherIcon icon="arrow-down" size={15} />
                              </button>

                              <button className='xl:text-sm 2xl:text-base hover:bg-red-500 text-red-500 font-semibold hover:text-white-100 py-1 px-2 border border-red-500 rounded mr-1'
                                onClick={() => handleExcluirComposicao(dashs.CodigoItem, dashs.Tipo, dashs.Exibindo)}>
                                <FeatherIcon icon="trash-2" size={15} />
                              </button>

                            </td>
                            <td className='truncate text-center px-2' >
                              {dashs.Ordem}
                            </td>
                            <td className='truncate text-left px-2 flex flex-row gap-[0.5rem] items-center ' >
                              {dashs.Tipo === 'DASH NATIVO' ?
                                <FeatherIcon icon="grid" size={15} />
                                : null
                              }
                              {dashs.Tipo === 'LINK' ?
                                <FeatherIcon icon="link" size={15} />
                                : null
                              }
                              {dashs.Tipo === 'VÍDEO' ?
                                <FeatherIcon icon="youtube" size={15} />
                                : null
                              }
                              {dashs.Tipo === 'IMAGEM' ?
                                <FeatherIcon icon="image" size={15} />
                                : null
                              }
                              {dashs.Tipo}
                            </td>
                            <td className='truncate text-left px-2' >{dashs.Exibindo}</td>
                            <td className='truncate text-right px-2'>{dashs.MinutosDuracao}</td>

                          </tr>
                        ))
                      ) : (
                        <tr className='bg-white-100 w-full'>
                          <td className='text-center italic text-sm' colSpan="5">Nenhum registro encontrado</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='flex flex-row gap-[1rem] '>

                  <div className=''>
                    <p style={{ opacity: idDashEdit ? 1 : 0.3 }} className='text-sm text-primaryColor '>
                      TIPO:
                    </p>
                    <select
                      style={{ opacity: idDashEdit ? 1 : 0.3 }}
                      required
                      disabled={idDashEdit ? false : true}
                      value={TipoCarrossel}
                      onChange={event => {
                        if (!idDashEdit) {
                          return
                        }
                        setTipoCarrossel(event.target.value)
                      }}
                      id='TipoCarrossel'
                      className={`w-full uppercase bg-gray-50 border border-gray-300  text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block  p-0.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                    >
                      <option key={'DASH NATIVO'} value={'DASH NATIVO'}>{'DASH NATIVO'}</option>
                      <option key={'LINK'} value={'LINK'}>{'LINK'}</option>
                      <option key={'IMAGEM'} value={'IMAGEM'}>{'IMAGEM'}</option>
                      <option key={'VÍDEO'} value={'VÍDEO'}>{'VÍDEO'}</option>
                    </select>

                    <div className=' w-full mt-2 '>
                      <p style={{ opacity: idDashEdit ? 1 : 0.3 }} className='text-xs text-primaryColor'>
                        MINUTOS
                      </p>
                      <input
                        style={{ opacity: idDashEdit ? 1 : 0.3 }}
                        autoComplete="off"
                        disabled={idDashEdit ? false : true}
                        maxLength={5} // Permitindo até 5 caracteres, por exemplo, 0.30
                        value={minutosCarrossel}
                        onChange={(event) => {
                          if (!idDashEdit) {
                            return
                          }
                          const value = event.target.value;
                          // Verificar se o valor inserido é um número ou um número seguido de ponto e mais números
                          if (/^\d*\.?\d*$/.test(value)) {
                            setMinutosCarrossel(value);
                          }
                        }}
                        onKeyPress={(e) => {
                          // Permitir apenas dígitos e o ponto
                          if (!/[\d.]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        id='minutosCarrossel'
                        className='w-full text-center uppercase pl-1 rounded-md shadow-lg text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                      />

                    </div>
                  </div>

                  <div className='w-full'>
                    <p style={{ opacity: TipoCarrossel === 'DASH NATIVO' && idDashEdit ? 1 : 0.3 }} className='text-sm text-primaryColor flex flex-row gap-[0.5rem] items-center '>
                      <FeatherIcon icon="grid" size={15} /> LISTA DE DASHS
                    </p>
                    <select
                      style={{ opacity: TipoCarrossel === 'DASH NATIVO' && idDashEdit ? 1 : 0.3 }}
                      required
                      disabled={idDashEdit ? false : true}
                      value={DashSelecionadoCarrossel}
                      onChange={event => {
                        if (!idDashEdit) {
                          return
                        }
                        setDashSelecionadoCarrossel(event.target.value)
                      }}
                      id='DashSelecionadoCarrossel'
                      className={`w-full uppercase bg-gray-50 border border-gray-300  text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block  p-0.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                    >
                      <option selected>Selecione um Dash</option>
                      {
                        dashboards_Full.filter(d => d.opTipoDash !== 'CARROSSEL').map(d => {
                          return (
                            <option key={d.Id} value={d.Id}>{d.NomeAmigavel}</option>
                          )
                        })
                      }
                    </select>

                    <p style={{ opacity: TipoCarrossel === 'LINK' && idDashEdit ? 1 : 0.3 }} className='text-sm text-primaryColor mt-2 flex flex-row gap-[0.5rem] items-center'>
                      <FeatherIcon icon="link" size={15} /> LINK/URL
                    </p>
                    <input
                      autocomplete="off"
                      disabled={idDashEdit ? false : true}
                      id='linkDash'
                      style={{ opacity: TipoCarrossel === 'LINK' ? 1 : 0.3 }}
                      type='url'
                      value={linkCarrossel}
                      onChange={event => {
                        if (!idDashEdit) {
                          return
                        }
                        setLinkCarrossel(event.target.value)
                      }}
                      placeholder='http://dashexterno.com.br/dash'
                      className='w-full px-1 rounded-md shadow-lg text-sm focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                    />

                    <p style={{ opacity: TipoCarrossel === 'IMAGEM' && idDashEdit ? 1 : 0.3 }} className='text-sm text-primaryColor mt-2 flex flex-row gap-[0.5rem] items-center'>
                      <FeatherIcon icon="image" size={15} /> IMAGEM
                    </p>
                    <label className="block">
                      <input
                        accept="image/png"
                        disabled={TipoCarrossel === 'IMAGEM' && idDashEdit ? false : true}
                        style={{
                          cursor: TipoCarrossel === 'IMAGEM' && idDashEdit ? 'pointer' : 'not-allowed',
                          opacity: TipoCarrossel === 'IMAGEM' && idDashEdit ? 1 : 0.3
                        }}
                        className={'file:cursor-pointer block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:text-sm file:font-semibold file:bg-white-100 file:border-primaryColor file:text-primaryColor hover:file:bg-primaryColorFocus hover:file:text-white-100'}
                        type="file"
                        id="ImagemCarrossel"
                      />
                    </label>

                    <p style={{ opacity: TipoCarrossel === 'VÍDEO' && idDashEdit ? 1 : 0.3 }} className='text-sm text-primaryColor mt-2 flex flex-row gap-[0.5rem] items-center'>
                      <FeatherIcon icon="youtube" size={15} /> VÍDEO
                    </p>
                    <label className="block">
                      <input
                        accept="video/*"
                        disabled={TipoCarrossel === 'VÍDEO' && idDashEdit ? false : true}
                        style={{
                          cursor: TipoCarrossel === 'VÍDEO' && idDashEdit ? 'pointer' : 'not-allowed',
                          opacity: TipoCarrossel === 'VÍDEO' ? 1 : 0.3
                        }}
                        className={'file:cursor-pointer block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:text-sm file:font-semibold file:bg-white-100 file:border-primaryColor file:text-primaryColor hover:file:bg-primaryColorFocus hover:file:text-white-100'}
                        type="file"
                        id="VideoCarrossel"
                      />
                    </label>

                    <button
                      className='w-full mt-[1rem] gap-[0.5rem] rounded  border border-green-500 text-green-500 hover:bg-green-500 hover:text-white-200  flex items-center justify-center p-[0.5rem] '
                      onClick={() => handleSalvarComposicao()}
                      style={{ opacity: idDashEdit && !isLoadingUploadFile ? 1 : 0.3 }}
                      disabled={idDashEdit && !isLoadingUploadFile ? false : true}
                    >
                      <FeatherIcon icon="plus-circle" size={25} />
                      <p className='font-bold text-sm ' >
                        {isLoadingUploadFile ?
                          'Salvando Composição, aguarde...'
                          :
                          'Salvar Composição'
                        }
                      </p>
                      {isLoadingUploadFile ?
                        <FeatherIcon icon="refresh-cw" size={25} />
                        :
                        null
                      }
                    </button>

                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            style={{ borderRadius: '0.5rem', marginTop: '1.5rem' }}
            className={`${styles.containerLogo} border border-thirdColor w-[55%]  flex flex-col shadow-lg`}
          >
            <div style={{ padding: '1rem' }} className={`${styles.divLogoEmpresa}`}>
              <div className='text-sm text-primaryColor font-semibold mb-1'>
                IMAGEM DE FUNDO (WALLPAPER)
              </div>
              <div style={{}} className='bg-white-100 rounded-lg shadow-lg  flex items-center justify-center'>
                <img
                  id="imgPreviewDash"
                  alt=''
                  src={'DashPreviewJPG.jpg'}
                  onError={(e) => { e.target.onError = null; e.target.src = 'DashPreviewJPG.jpg' }}
                  className='h-[15rem] w-[20rem]' />
              </div>
              <label className="block mt-3">
                <input
                  accept="image/png"
                  disabled={disable}
                  style={{
                    cursor: disable ? 'not-allowed' : 'pointer',
                    opacity: disable ? 0.5 : 1
                  }}
                  className={'file:cursor-pointer block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:text-sm file:font-semibold file:bg-white-100 file:border-primaryColor file:text-primaryColor hover:file:bg-primaryColorFocus hover:file:text-white-100'}
                  type="file"
                  id="fileInputDash"
                  onChange={(e) => uploadFile(e.target.files, idDashEdit)}
                />
              </label>
              <button
                className={`bg-white-100 mt-2 text-sm flex flex-row justify-center  items-center hover:bg-red-500 text-red-500 font-semibold hover:text-white-100 py-1 px-2 border border-red-500 rounded shadow-lg`}
                onClick={() => deleteImagemFundoDash(idDashEdit)}
              >
                <p className='text-xl' ></p>Excluir Imagem
              </button>
            </div>
          </div>

          <div className={`${styles.divBotaoSave} w-full  flex justify-end mt-10`}>
            <button
              className={`${styles.botaoSave} bg-white-100  ml-2 text-sm flex flex-row justify-center  items-center hover:bg-red-500 text-red-500 font-semibold hover:text-white-100 py-1 px-2 border border-red-500 rounded shadow-lg`}
              onClick={() => handleClearInputs()}
            >
              <p className='text-xl' >🚫</p> &nbsp; Limpar formulário
            </button>

            <button
              style={{
                opacity: disable ? 0.5 : 1
              }}
              className={`${styles.botaoSave} bg-white-100 ${disable && 'cursor-not-allowed'} ml-2 text-sm flex flex-row justify-center  items-center hover:bg-primaryColor text-primaryColor font-semibold hover:text-white-100 py-1 px-2 border border-primaryColor rounded shadow-lg`}
              disabled={disable}
              onClick={() => criaDashboard()}
            >
              <CloudSave width="2em" height="2em" /> &nbsp; {textButtonSave}
            </button>
          </div>

        </div>
      </div>
    )
  }

  async function handleRenderLinkDash(dash) {

    //localStorage.removeItem("dashboardRecents")

    const storedDashboardRecents = localStorage.getItem('dashboardRecents');

    let dashList = [];

    // Verifica se há dados no localStorage
    if (storedDashboardRecents) {
      // Se houver dados, converte para array e atribui a dashList
      dashList = JSON.parse(storedDashboardRecents);
    }

    const newDashboard = {
      user: user,
      Descricao: dash.Descricao,
      LinkDash: dash.LinkDash,
      NomeAmigavel: dash.NomeAmigavel,
      timestamp: new Date().toISOString()
    };

    // Remove da lista caso exista
    dashList = dashList.filter((dashboard) => dashboard.Descricao !== newDashboard.Descricao)

    dashList.push(newDashboard);

    // Salva a lista atualizada no localStorage
    localStorage.setItem('dashboardRecents', JSON.stringify(dashList));

    //const registrosDashPermitidos = await getListaDashPermitidosUsuario()

    const registrosDashPermitidos = await getListaDashPermitidosUsuario()

    if (registrosDashPermitidos.filter(d => d.Descricao == dash.Descricao).length > 0) {
      if (dash.LinkDash) {
        addTab('renderlinkdash')
        setLinkDashContext(dash.LinkDash)
      }
      else {
        addTab(dash.Descricao)
      }
      await GravaLogB2B("ACESSO - " + dash.NomeAmigavel, user.cnpj);
    }
    else {
      Swal.fire({
        icon: 'error',
        text: 'Dash não habilitado nas configurações de Usuário!',
        showConfirmButton: false,
        timer: 5000
      })
    }

  }

  function handleNewTab(dash) {
    localStorage.manterLogin = "true"
    localStorage.DescricaoDashAtual = dash.Descricao
  }



  const renderAbaListaDash = () => {
    return (
      <>

        <ListaDashboards
          Altura='h-[60vh]'
          dashFiltro={dashFiltro}
          setDashfiltro={setDashfiltro}
          dashboards={dashboards}
          showEditButtom={true}
          encheCamposTela={encheCamposTela}
          excluiDashBoard={excluiDashBoard}
          handleRenderLinkDash={handleRenderLinkDash}
          handleNewTab={handleNewTab}
        />
        {
          /* 
          <div className={`${styles.tabelas}  overflow-x-hidden overflow-y-scroll border border-thirdColor div-scroll-hidden `}>
          <table className={`w-full border-collapse div-scroll-hidden  `}>
            <thead>
              <tr className='bg-primaryColor text-white-100 font-semibold text-sm'>
                <th className='md:w-5 text-center'>Editar / Excluir</th>
                <th className='w-7'>Id</th>
                <th className='md:w-28 text-left'>Nome do Dash</th>
                <th className='md:w-36 text-left'>Nome Amigável</th>
                <th className='md:w-36 text-left'>Departamento</th>
              </tr>
            </thead>
            <tbody className='text-xs xl:text-sm uppercase'>
              {dashboards.length > 0 ? (
                dashboards.map((dashboard, key) => (
                  <tr key={key} className='odd:bg-white-100 even:bg-lightgray text-sm'>
                    <td className='flex flex-row justify-center py-2'>
                      <button className='xl:text-sm 2xl:text-base hover:bg-primaryColor text-primaryColor font-semibold hover:text-white-100 py-1 px-2 border border-primaryColor rounded mr-1'
                        onClick={() => encheCamposTela(key)}>
                        <FeatherIcon icon="edit" size={14} />
                      </button>
                      <button className='xl:text-sm 2xl:text-base hover:bg-red-500 text-red-500 font-semibold hover:text-white-100 py-1 px-2 border border-red-500 rounded'
                        onClick={() => excluiDashBoard(key)}>
                        <FeatherIcon icon="trash" size={14} />
                      </button>
                    </td>
                    <td className='text-center'>{dashboard.Id}</td>
                    <td>{dashboard.Descricao}</td>
                    <td>{dashboard.NomeAmigavel}</td>
                    <td>{dashboard.Departamento}</td>
                  </tr>
                ))
              ) : (
                <tr className='bg-white-100 w-full'>
                  <td className='text-center italic text-sm' colSpan="5">Nenhum registro encontrado</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
          
          */
        }
      </>

    )
  }

  return (
    <div className="screensDash div-scroll-hidden h-full">
      <div className="flex flex-row h-full w-full div-scroll-hidden ">
        <div className="flex flex-col h-full  w-full overflow-y-auto div-scroll-hidden ">
          <BarraDeTitulo Titulo={'CADASTRO DE DASHBOARD'} />
          {isLoadingCarrossel ?
            <LoadingSpinner />
            : <></>
          }
          <div className="px-5 p-4 flex flex-col max-h-[86.5%] overflow-auto ">
            <div className="containerGuia scrollable">
              <div className="bloc-tabs">
                <button
                  className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
                  onClick={() => toggleTab(1)}
                >
                  {`Lista de Dashboard (${dashboards.length || 0})`}
                </button>
                <button
                  className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
                  onClick={() => toggleTab(2)}
                >
                  {textSegundaAba}
                </button>
              </div>
              <div className="content-tabs">
                <div
                  className={toggleState === 1 ? "content  active-content" : "content"}
                >
                  {renderAbaListaDash()}
                </div>
                <div
                  className={` ${toggleState === 2 ? "content  active-content" : "content"}`}
                >
                  {renderAbaCadastrarNovoDash()}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}
